module.exports = __webpack_public_path__ + "img/global-not_found.png?d0375003";